import { TAttachmentDB } from '../../types/db';
import axios from 'axios';
import { memberApi } from '../../lib/api';
import db from './db';

class AttachmentModel implements TAttachmentDB {
  id: string;
  type: string | null;
  size: string | null;
  name: string | null;
  blob: Blob | null;
  url?: string;

  constructor({ id, type, size, name, blob }: TAttachmentDB) {
    this.id = id;
    this.type = type;
    this.size = size;
    this.name = name;
    this.blob = blob;
    this.url = '';
  }

  static async processAttachment(attachment: TAttachmentDB) {
    const record = await db.attachments.get(attachment.id);
    if (record) {
      return new AttachmentModel(record);
    } else {
      const model = new AttachmentModel(attachment);
      await model.createBlobAndUrl();
      if (model.blob && model.blob.type !== 'application/octet-stream') {
        await model.save();
      }
      return model;
    }
  }

  async createBlobAndUrl() {
    try {
      const imageUrlReq = (await memberApi.getAttachment(this.id)) as any;
      const url = imageUrlReq.data.data.path;
      const res = await axios({
        url,
        method: 'get',
        responseType: 'blob',
      });
      this.blob = res.data;
      this.url = url;
    } catch {
      return null;
    }
  }

  async save() {
    return await db.attachments.put({
      id: this.id,
      type: this.type,
      name: this.name,
      blob: this.blob,
      size: this.size,
    });
  }
}

export default AttachmentModel;
